import { useQuery } from "@tanstack/react-query";
import {
  getReferrals,
  type GetReferralsParams,
  type GetReferralsResult,
} from "../../api/referrals";
import { queryKeys } from "./queryKeys";

export function useReferrals(params: GetReferralsParams = {}) {
  return useQuery<GetReferralsResult>({
    queryKey: queryKeys.referrals.list(params),
    queryFn: () => getReferrals(params),
    // VISION referrals arrive continuously; the 5-minute app default hid new
    // ones until the cache expired.
    staleTime: 15 * 1000,
    refetchOnMount: "always",
  });
}
